import { Component } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { MdDialog } from "@angular/material";
import { ErrorHandler } from "../../shared/services/error-handler.service";
import { HttpService } from "../../shared/services/http.service";
import { SessionHandler } from "../../shared/services/session-handler.service";
import { CommonService } from "../../shared/services/common.service";
import { FormBuilder } from "@angular/forms";
import { dialogComponent } from "../../dialog/dialog.component";
import { itemClass, itemClassEditManual } from "../foc-return/foc-itemClass";
import { FOCviewDialog } from "../foc-create/foc-create.component";

@Component({
    selector: 'request-add',
    template: require('./foc-confirm.component.html'),
    styles: [require('./foc-confirm.component.scss')],
    providers: [HttpService, ErrorHandler, SessionHandler]
})

export class FOCviewRequestConfirmComponent {

    dialogRef;
    userData: any;
    item_list: any = [];
    finalFormData: any = [];
    serialNumberList: any = [];
    tradeData:any = {};
    itemReason = [];
    uploadedDocList:any=[];
    showEditSerial = [];
    reasonList: any;
    reason: any;
    id: any;
    returnOrder: any = {};
    isUpload: boolean = false;
    isManual: boolean = false;
    showList: boolean = false;
    isD2CUser:boolean=false;
    showingMediaErrorMsg:any;
    showingmediaError:any;
    sapFOCNo:any;
    totalAmount: number = 0;
    constructor(private router: Router, private route: ActivatedRoute, private http: HttpService, private formBuilder: FormBuilder, private commonService: CommonService,
        private sessionHandler: SessionHandler, private dialog: MdDialog) {

        this.userData = {};
        this.finalFormData = {};
        this.finalFormData.requestOrder = {};
        if (this.http.checkSession()) {
            this.finalFormData.requestOrder = [];
            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
            let data = this.commonService.getData();
            console.log(data)
            
            this.route.params.subscribe(params => {
                this.id = +params['id'];
            });
            if (!isNaN(this.id)) {
                if (data && data['returnOrder']) {
                    this.isD2CUser=data.d2C;/**added for  D2c one time address */
                    this.finalFormData = data;
                    if(this.finalFormData.status=="REJECTED_FOR_INCOMPLETENESS"){
                        this.finalFormData.status="REJECTED FOR INCOMPLETENESS"
                    }
                    this.commonService.changeViewData(this.finalFormData);
                    this.returnOrder = data['returnOrder'];

                    const rawItems = (this.returnOrder.items || []).map(x =>
                        x.data ? x.data : x
                    );
                    
                    this.item_list = rawItems.map(it => ({
                        modelNumber: it.modelNumber,
                        itemID: it.itemID,
                        invoicedQuantity: Number(it.invoicedQuantity),
                        serialNumber: Array.isArray(it.serialNumber) ? it.serialNumber.slice() : [],
                        reasonCode: it.reasonCode,
                        cost: it.cost,
                        currency: it.currency
                    }));
                    
                    console.log("CONFIRM FINAL ITEM LIST (clean) >>>", this.item_list);
                    // if (this.finalFormData.returnItemUploadFlag == 2 || this.finalFormData.returnItemUploadFlag == 'INVOICE_NUMBER') {
                    //     this.setReturnData();
                    // } else if (this.finalFormData.returnItemUploadFlag == 0 || this.finalFormData.returnItemUploadFlag == 1 || this.finalFormData.returnItemUploadFlag == 'INSERT_MANUAL' || this.finalFormData.returnItemUploadFlag == 'UPLOAD_FILE') {
                    //     this.setReturnDataManual();
                    // }
                } else {
                    // this.getRequestDataWithId();
                }
            }
        } else {
            this.http.showSessionError();
        }
    }

    ngOnInit() { 
        this.getRequestDataWithId();

    }
       imageShow(data){
        this.http.showLoader();
        this.http.downloadPostRequest('document/downloadDocument',data).subscribe(
          res => {
            this.sanitizeUrl(res['data'])
            this.http.onEnd();
        },
         err => {
            this.http.onEnd();
           this.showingMediaErrorMsg ="error in fetch image data";
           this.showingmediaError =true;
         }
        );   
    }
    sanitizeUrl(data){

        this.uploadedDocList =data;
        console.log("uploaded docs,",this.uploadedDocList);
    }
    
  public navigateDocLink(docUrl){    
        this.dialogRef = this.dialog.open(FOCviewDialog);
        this.dialogRef.componentInstance.urlList = docUrl;
        this.http.onEnd();
    }

    public getRequestDataWithId() {
        this.http.getRequest('focApi/v1/getFOCRequestDetail?FOCId='+ this.id)
        .subscribe(
                res => { this.saveRequestData(res) },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                    this.http.onEnd();
                });
    }


calculateTotal() {
  let total = 0;

  if (this.item_list && this.item_list.length > 0) {
    for (let group of this.item_list) {
      if (Array.isArray(group)) {
        for (let item of group) {
          const cost = Number(item.cost) || 0;
          const qty =
            Number(item.quantity || item.invoicedQuantity) || 0;

          total += cost * qty;
        }
      }
    }
  }

  this.totalAmount = total;
}
   public getTradeData(id){
        this.http.getRequest('tradePartnerDetails/v1/get?tradePartnerId='+ id)
        .subscribe(
            res => {
                this.saveTradeData(res)
                },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                    this.http.onEnd();
        });
    }
    
    public saveTradeData(res) {
        if(res.status == "Success") {
            this.tradeData = res.tradePartner;
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Not able to fetch trade data.';
        }
        this.http.onEnd();
    }

    public saveRequestData(res) {
        if (res.status == 'Success') {
            
            this.getTradeData(res.FOCRequestDetail.soldTo);
            this.finalFormData = res.FOCRequestDetail;
            if(this.finalFormData.status=="REJECTED_FOR_INCOMPLETENESS"){
                console.log("Inside if");
                this.finalFormData.status="REJECTED FOR INCOMPLETENESS" ;
            }
            this.returnOrder = res.FOCRequestDetail;
            console.log("Final Data",this.finalFormData)
            if (this.returnOrder.focProductList && this.returnOrder.focProductList.length > 0) {
                this.item_list = [ this.returnOrder.focProductList ]; // nested array for UI
            } else {
                this.item_list = [];
            }
           this.calculateTotal();
           this.sapFOCNo=
            {
                transactionId:res.FOCRequestDetail.sapFOCNo
            }
            this.commonService.changeViewData(this.finalFormData);
            
             this.imageShow(this.sapFOCNo);     //Call ServiceDoc Api
        }
        this.http.onEnd();
    }
/** for d2c user*/
setd2cUserAddress(data){
    let addressArray=data.pickupAddress.split('#');
    let nameArray=data.contactName.split(' ')
    let onetTimeAddress= {
        'name1': nameArray[0],
        'name2': nameArray[1],
        'contactEmail': data.contactEmail,
        'contactPhone': data.contactPhone,
        'street': addressArray[0],
        'city': addressArray[1],
        'country': addressArray[2],
        'zipCode': addressArray[3],
    }
    this.finalFormData.requestOrder['tpDetails']=onetTimeAddress;
    this.finalFormData.requestOrder['contactEmail']=null;
    this.finalFormData.requestOrder['contactName']=null;
    this.finalFormData.requestOrder['contactPhone'] = null;
    this.finalFormData.requestOrder['pickupAddress']=null;
}

    public getReasonList() {
        this.http.getRequest('tradePartnerDetails/v1/getReasonCode')
            .subscribe(
                res => { this.saveReasonList(res) },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                    this.http.onEnd();
                });
    }

    public saveReasonList(res) {
        if (res && res.items) {
            this.reasonList = res.items;
            this.sessionHandler.saveItem('reasons', JSON.stringify(this.reasonList));
            for (let r in this.reasonList) {
                if (this.finalFormData.returnOrder && this.finalFormData.returnOrder.reason == this.reasonList[r].reasonCode) {
                    this.reason = this.reasonList[r].reason;
                }
            }
        }
        this.http.onEnd();
    }


    public setReturnData() {
        this.reasonList = JSON.parse(this.sessionHandler.getItem('reasons'));
        if (this.reasonList == null || this.reasonList.length < 0) {
            this.getReasonList();
        } else {
            for (let r in this.reasonList) {
                if (this.finalFormData.returnOrder && this.finalFormData.returnOrder.reason == this.reasonList[r].reasonCode) {
                    this.reason = this.reasonList[r].reason;
                }
            }
        }

        if (this.finalFormData.returnItemUploadFlag == 'INSERT_MANUAL' || this.finalFormData.returnItemUploadFlag == '0' || this.finalFormData.returnItemUploadFlag == 0) {
            this.isManual = true;
        } else if (this.finalFormData.returnItemUploadFlag == 'UPLOAD_FILE' || this.finalFormData.returnItemUploadFlag == '1' || this.finalFormData.returnItemUploadFlag == 1) {
            this.isUpload = true;
        }

        if (this.returnOrder.items) {
            let returnOrder = [];
            for (let i in this.returnOrder.items) {
                if (this.returnOrder.items[i]['data']) {
                    returnOrder.push(this.returnOrder.items[i]['data']);
                } else {
                    returnOrder.push(this.returnOrder.items[i]);
                }
            }
            this.item_list = returnOrder;

            let serials: any = [];
            let qty: any = [];
            let models: any = [];
            let invoice: any = [];
            let final: any = [];
            let items: any = [];
            let itemList: any = [];
            let itemList1: any = [];

            for (let i in this.item_list) {

                let reason = null;
                serials[i] = [];
                qty[i] = [];
                models[i] = [];
                invoice[i] = [];
                final[i] = [];
                let dummyItems: itemClass[] = [];
                items.push(dummyItems);
                itemList[i] = [];
                itemList1[i] = [];

                if (this.isManual || this.isUpload) {
                    if (this.item_list[i]) {
                        for (let r in this.reasonList) {
                            if (this.item_list[i].reasonCode == this.reasonList[r].reasonCode) {
                                reason = this.reasonList[r].reason;
                            }
                        }
                        if (this.item_list[i].serialNumber) {
                            items[i].push(new itemClass(this.item_list[i].invoiceDocumentID, this.item_list[i].customerMaterialNumber, this.item_list[i].serialNumber, this.item_list[i].itemID, this.item_list[i].invoicedQuantity, reason, true));
                        } else {
                            items[i].push(new itemClass(this.item_list[i].invoiceDocumentID, this.item_list[i].customerMaterialNumber, null, this.item_list[i].itemID, this.item_list[i].invoicedQuantity, reason, true));
                        }
                    }
                } else {
                    for (let j in this.item_list[i]) {
                        if (this.item_list[i][j]) {
                            for (let r in this.reasonList) {
                                if (this.item_list[i][j].reasonCode == this.reasonList[r].reasonCode) {
                                    reason = this.reasonList[r].reason;
                                }
                            }
                            if (this.item_list[i][j].serialNumber) {
                                items[i].push(new itemClass(this.item_list[i][j].invoiceDocumentID, this.item_list[i][j].customerMaterialNumber, this.item_list[i][j].serialNumber, this.item_list[i][j].itemID, this.item_list[i][j].invoicedQuantity, reason, true));
                            } else {
                                items[i].push(new itemClass(this.item_list[i][j].invoiceDocumentID, this.item_list[i][j].customerMaterialNumber, null, this.item_list[i][j].itemID, this.item_list[i][j].invoicedQuantity, reason, true));
                            }
                        }
                    }
                }
            }

            for (let i in items) {
                for (let j in items[i]) {
                    if (models[i].indexOf(items[i][j].modelNumber) == -1) {
                        models[i].push(items[i][j].modelNumber);
                    }
                }
            }

            if (!this.isUpload) {
                for (let i in items) {
                    for (let j in items[i]) {
                        if (invoice[i].indexOf(items[i][j].invoiceDocumentID) == -1) {
                            invoice[i].push(items[i][j].invoiceDocumentID);
                        }
                    }
                }
            }

            if (!this.isUpload) {
                for (let i in models) {
                    for (let j in models[i]) {
                        serials[i][models[i][j]] = [];
                        qty[i][models[i][j]] = 0;
                        for (let k in items) {
                            for (let l in items[k]) {
                                let rawSerial = {};
                                if (invoice[i][0] == items[k][l].invoiceDocumentID) {
                                    if (models[i][j] == items[k][l].modelNumber) {
                                        qty[i][models[i][j]] += parseInt(items[k][l].invoicedQuantity);
                                        if ((items[k][l].serialNumber)) {
                                            rawSerial = items[k][l].serialNumber;
                                        } else {
                                            rawSerial = '';
                                        }
                                        if ((items[k][l].serialNumber)) {
                                            serials[i][models[i][j]].push(rawSerial);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                for (let i in models) {
                    for (let j in models[i]) {
                        serials[i][models[i][j]] = [];
                        qty[i][models[i][j]] = 0;
                        for (let k in items) {
                            for (let l in items[k]) {
                                let rawSerial = {};
                                if (models[i][j] == items[k][l].modelNumber) {
                                    qty[i][models[i][j]] += parseInt(items[k][l].invoicedQuantity);
                                    if ((items[k][l].serialNumber)) {
                                        rawSerial = items[k][l].serialNumber;
                                    } else {
                                        rawSerial = '';
                                    }
                                    if ((items[k][l].serialNumber)) {
                                        serials[i][models[i][j]].push(rawSerial);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            if (!this.isUpload) {
                for (let m in models) {
                    for (let n in models[m]) {
                        for (let i in items) {
                            for (let j in items[i]) {
                                if (invoice[m][0] == items[i][j].invoiceDocumentID) {
                                    if (models[m][n] == items[i][j].modelNumber) {
                                        final[i][j] = [];
                                        final[i][j] = items[i][j];
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                for (let m in models) {
                    for (let n in models[m]) {
                        for (let i in items) {
                            for (let j in items[i]) {
                                if (models[m][n] == items[i][j].modelNumber) {
                                    final[i][j] = [];
                                    final[i][j] = items[i][j];
                                    break;
                                }
                            }
                        }
                    }
                }
            }

            if (!this.isUpload) {
                for (let f in final) {
                    for (let g in final[f]) {
                        for (let s in serials) {
                            for (let t in serials[s]) {
                                if (final[f][g].invoiceDocumentID == invoice[s][0] && final[f][g].modelNumber == t) {
                                    final[f][g].invoicedQuantity = qty[s][t];
                                    final[f][g].serialNumber = serials[s][t];
                                }
                            }
                        }
                        itemList[f].push(final[f][g]);
                    }
                }
            } else {
                for (let f in final) {
                    for (let g in final[f]) {
                        for (let s in serials) {
                            for (let t in serials[s]) {
                                if (final[f][g].modelNumber == t) {
                                    final[f][g].invoicedQuantity = qty[s][t];
                                    final[f][g].serialNumber = serials[s][t];
                                }
                            }
                        }
                        itemList[f].push(final[f][g]);
                    }
                }
            }
            this.item_list = itemList;
        }
    }

    //FOR MANUAL ENTRIES
    public setReturnDataManual() {
        if (this.finalFormData.returnItemUploadFlag == 'INSERT_MANUAL' || this.finalFormData.returnItemUploadFlag == '0' || this.finalFormData.returnItemUploadFlag == 0) {
            this.isManual = true;
        } else if (this.finalFormData.returnItemUploadFlag == 'UPLOAD_FILE' || this.finalFormData.returnItemUploadFlag == '1' || this.finalFormData.returnItemUploadFlag == 1) {
            this.isUpload = true;
        }

        if (this.returnOrder.items) {
            this.item_list = Object.assign([], this.returnOrder.items);
            if (this.item_list && this.item_list.length > 0) {
                if (this.item_list[0].modelNumber) {
                    this.setItemListManual();
                } else {
                    this.setItemDataForEditManual();
                }
            }
        }
        this.showList = true;
    }

    public setItemListManual() {
        for (let i in this.item_list) {
            if (parseInt(this.item_list[i].invoicedQuantity) > 0) {
                this.showEditSerial[i] = false;
                this.serialNumberList[i] = [];
                if (this.isManual) {
                    this.item_list[i].done = true;
                }
                if (this.item_list[i].serialNumber && Object.keys(this.item_list[i].serialNumber).length > 0) {
                    for (let x in this.item_list[i].serialNumber) {
                        if (this.item_list[i].serialNumber[x] && Object.keys(this.item_list[i].serialNumber[x]).length > 0) {
                            if (!this.isItemInArray(this.serialNumberList[i], this.item_list[i].serialNumber[x].value)) {
                                this.serialNumberList[i].push(this.item_list[i].serialNumber[x]);
                            }
                        }
                    }
                }
                let count = 0;
                for (let x in this.serialNumberList[i]) {
                    if (this.serialNumberList[i][x].value && this.serialNumberList[i][x].value != '') {
                        count++;
                    }
                }
                if (count < parseInt(this.item_list[i].invoicedQuantity)) {
                    this.showEditSerial[i] = true;
                }
                if (this.item_list[i].reasonCode) {
                    this.itemReason[i] = this.item_list[i].reasonCode;
                }
            }
        }
    }

    public setItemDataForEditManual() {
        if (this.item_list) {
            let serials: any = [];
            let qty: any = [];
            let models: any = [];
            let final: any = [];
            let items: itemClassEditManual[] = [];
            let itemList: any = [];
            for (let i in this.item_list) {
                if (this.item_list[i]) {
                    if (!this.item_list[i].id) {
                        this.item_list[i].id = '';
                    }
                    let reason = null;
                    if (this.item_list[i].reasonCode) {
                        reason = this.item_list[i].reasonCode;
                    }
                    let maxQuantity = '';
                    if (this.item_list[i].maxQuantity && this.item_list[i].maxQuantity != '') {
                        maxQuantity = this.item_list[i].maxQuantity
                    }
                    if (this.item_list[i].serialNumber) {
                        items.push(new itemClassEditManual(this.item_list[i].id, this.item_list[i].customerMaterialNumber, this.item_list[i].serialNumber, this.item_list[i].itemID, reason, this.item_list[i].invoicedQuantity, maxQuantity, true));
                    } else {
                        items.push(new itemClassEditManual(this.item_list[i].id, this.item_list[i].customerMaterialNumber, null, this.item_list[i].itemID, reason, this.item_list[i].invoicedQuantity, maxQuantity, true));
                    }
                }
            }

            for (let i in items) {
                if (models.indexOf(items[i].modelNumber) == -1) {
                    models.push(items[i].modelNumber);
                }
            }

            for (let m in models) {
                serials[models[m]] = [];
                qty[models[m]] = 0;
                for (let i in items) {
                    let rawSerial = {};
                    if (models[m] == items[i].modelNumber) {
                        qty[models[m]] += parseInt(items[i].invoicedQuantity);
                        if (items[i].id) {
                            rawSerial['id'] = items[i].id;
                        } else {
                            rawSerial['id'] = '';
                        }
                        if ((items[i].serialNumber)) {
                            rawSerial['value'] = items[i].serialNumber;
                        } else {
                            rawSerial['value'] = '';
                        }
                        serials[models[m]].push(rawSerial);
                    }
                }
            }

            for (let m in models) {
                for (let i in items) {
                    if (models[m] == items[i].modelNumber) {
                        final[i] = [];
                        final[i] = items[i];
                        break;
                    }
                }
            }

            for (let f in final) {
                for (let s in serials) {
                    if (final[f].modelNumber == s) {
                        final[f].invoicedQuantity = qty[s];
                        final[f].serialNumber = serials[s];
                    }
                }
                itemList.push(final[f]);
            }
            this.item_list = itemList;
            if (this.item_list && this.item_list.length > 0) {
                this.setItemListManual();
            }
        }
    }
    // END Maual Functions

    public isItemInArray(array, item) {
        if (array) {
            for (var i = 0; i < array.length; i++) {
                // This if statement depends on the format of your array
                if (array[i].value == item) {
                    return true;   // Found it
                }
            }
        }
        return false;   // Not found
    }

    public goToPreviousPage() {
        this.router.navigateByUrl('/app/foc-view/return/' + this.id);
    }

    public cancel() {
        this.router.navigateByUrl('/app/foc_dashboard');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/FOCviewRequest/foc-confirm/foc-confirm.component.ts